import * as type from "./mutation-types.js";
import Cookies from 'js-cookie';

export default {
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set("sidebarStatus", 1);
    } else {
      Cookies.set("sidebarStatus", 0);
    }
  },

  [type.SET_BREADCRUMB](state, breadcrumb) {
    state.breadcrumb = breadcrumb;
  },
  [type.SET_USER_INFO](state, userinfo) {
    state.nickname = userinfo.nickname;
    state.share_user = userinfo.share_user;
    state.share_time = userinfo.share_time;
    state.share_ip = userinfo.share_ip;
    state.description = userinfo.description;
    state.menu = userinfo.menu;
    state.menu_loaded = true;
  },
  [type.CLEAR_USER_INFO](state, userinfo) {
    state.nickname = "";
    state.menu = [];
    state.menu_loaded = false;
  },
  [type.SET_ROUTER](state, router) {
    state.router = router;
  },
  [type.SET_THEME](state, theme) {
    state.theme = theme;
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js